<div style="width: 500px; height: 280px;" data-cy="fee-schedule-create-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="fee-schedule-create-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="fee-schedule-create-header">
      <div class="section-header-title" data-cy="fee-schedule-create-title">
        New Insurance Company
      </div>
      <div style="flex: 1;"></div>
    </div>

    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; text-align: center;" data-cy="fee-schedule-create-content">
      <div style="text-align: center; color: var(--tdo-primary); width: 100%; height: 100%;" *ngIf="isLoading" data-cy="fee-schedule-create-loading">
        <div data-cy="fee-schedule-create-loading-text">Saving</div>
        <app-tdo-progress-spinner data-cy="fee-schedule-create-spinner"></app-tdo-progress-spinner>
      </div>
      <div *ngIf="!isLoading" data-cy="fee-schedule-create-form">
        <mat-form-field class="insurance-company-input-field full-width" data-cy="fee-schedule-create-company-field">
          <mat-label data-cy="fee-schedule-create-company-label">Insurance Company</mat-label>
          <mat-select
            required
            [(ngModel)]="newScheduleObject.organizationID"
            (selectionChange)="changeDescription($event)"
            data-cy="fee-schedule-create-company-select">
            <mat-option *ngFor="let organization of organizations"
                        [value]="organization.OrganizationID"
                        data-cy="fee-schedule-create-company-option">
              {{ organization.OrganizationName }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <br />

        <mat-form-field class="name-form full-width" *ngIf="!editMode" data-cy="fee-schedule-create-name-field">
          <input matInput
                 placeholder="Fee Schedule Name"
                 value=""
                 [(ngModel)]="newScheduleObject.name"
                 data-cy="fee-schedule-create-name-input" />
        </mat-form-field>

        <mat-form-field class="name-form full-width" *ngIf="editMode" data-cy="fee-schedule-edit-name-field">
          <input matInput
                 placeholder="Fee Schedule Name"
                 value=""
                 [(ngModel)]="newScheduleObject.name"
                 data-cy="fee-schedule-edit-name-input" />
        </mat-form-field>
      </div>
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="fee-schedule-create-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onCancelClick()" class="tdo-button tdo-close" style="margin-right: 6px;" data-cy="fee-schedule-create-cancel-button">Cancel</button>
      <button [disabled]="!newScheduleObject.name || this.newScheduleObject.organizationID == null || isLoading" (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="fee-schedule-create-ok-button">Ok</button>
    </div>
  </div>
</div>
